export default __webpack_public_path__ + "static/media/ord-pack-v.d943c832.png";